import Component from './component';

const LifestyleCard = (props) => <Component {...props} />;

export default LifestyleCard;

export { Component as component };
